import { createContext } from 'react';

import { DesignProvider } from '../chromatic-lib/constants/DesignProvider';
import { LoginProvider } from '../chromatic-lib/constants/LoginProvider';

export interface AuthCallbackContextType {
  onLoginWithCredentials: (credentials: {
    email: string;
    password: string;
    withReloadOnSuccess?: boolean;
  }) => Promise<void>;
  onLoginWithProvider: (provider: LoginProvider | DesignProvider) => Promise<void>;
  onLogout: (goHome?: boolean) => Promise<void>;
}

export const AuthCallbackContext = createContext<AuthCallbackContextType>({
  onLogout: async () => {},
  onLoginWithCredentials: async () => {},
  onLoginWithProvider: async () => {},
});
